export enum RotationTreeEnum {
    PortCall = 0,
    BerthCall = 1,
    CargoOperation = 2,
    Sea = 3,
}
